const patientListScreenMessages = {
    addProfileHeader : 'Who’s taking the test?',
    selectUser : 'Select a user',
    testTimelineHeader : 'Test timeline for ',
    tesDateLabel : 'Test date',
    resultLabel : 'Result',
};

export default patientListScreenMessages;